import { Card, Flex, Statistic, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { formatBytes } from '@/shared/lib/format'
import type { UsageSummary } from './usageApi'

export function UsageSummaryCard({ summary }: { summary: UsageSummary }) {
  const { t } = useTranslation()

  return (
    <Card title={t('usage.totalLabel')}>
      <Typography.Title level={2} style={{ margin: 0 }}>
        {formatBytes(summary.totalBytes)}
      </Typography.Title>
      {summary.freeBytes > 0 && (
        <>
          <Flex gap={32} wrap style={{ marginTop: 16 }}>
            <Statistic
              title={t('usage.countedLabel')}
              value={formatBytes(summary.countedBytes)}
              valueStyle={{ fontSize: 18 }}
            />
            <Statistic
              title={t('usage.freeLabel')}
              value={formatBytes(summary.freeBytes)}
              valueStyle={{ fontSize: 18 }}
            />
          </Flex>
          <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12, marginTop: 8 }}>
            {t('usage.freeHint')}
          </Typography.Text>
        </>
      )}
    </Card>
  )
}
